module.exports = __webpack_public_path__ + "img/hand-image.ca105836.png";